import React from 'react';
import * as PropTypes from 'prop-types';
import { Button, Circle, Icon } from './elements';

function Btn30(props) {
  return (
    <Button
      aria-label={props.ariaLabel}
      checked={props.checked}
      disabled={props.disabled}
      onClick={!props.disabled && props.onClick ? props.onClick : null}
    >
      <Circle
        className={props.className}
        checked={props.checked}
        disabled={props.disabled}
      >
        <Icon
          checked={props.checked}
          disabled={props.disabled}
          icon={props.icon ? props.icon : 'icon-check'}
        />
      </Circle>
    </Button>
  );
}

Btn30.propTypes = {
  ariaLabel: PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Btn30;
